export default function DocumentIcon() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Document Icon</title>
      <rect width="56" height="56" rx="10" fill="white" fillOpacity="0.06" />
      <path
        d="M18.8267 33.3258C18.8267 35.4474 20.5518 37.1726 22.6735 37.1726H33.3262C35.4479 37.1726 37.1731 35.4474 37.1731 33.3258V24.7858C37.1731 23.759 36.7736 22.7914 36.0457 22.0664L33.9329 19.9536C33.2049 19.2256 32.2402 18.8262 31.2134 18.8262H22.6735C20.5518 18.8262 18.8267 20.5513 18.8267 22.673V33.3258ZM20.6021 22.673C20.6021 21.5308 21.5313 20.6016 22.6735 20.6016H31.2134C31.7668 20.6016 32.2876 20.8176 32.6782 21.2082L34.791 23.321C35.1816 23.7116 35.3976 24.2324 35.3976 24.7858V33.3258C35.3976 34.468 34.4685 35.3971 33.3262 35.3971H22.6735C21.5313 35.3971 20.6021 34.468 20.6021 33.3258V22.673Z"
        fill="white"
      />
      <path
        d="M25.0406 31.255H30.9588C31.447 31.255 31.8465 30.8555 31.8465 30.3672C31.8465 29.879 31.447 29.4795 30.9588 29.4795H25.0406C24.5523 29.4795 24.1528 29.879 24.1528 30.3672C24.1528 30.8555 24.5523 31.255 25.0406 31.255Z"
        fill="white"
      />
      <path
        d="M25.0406 26.5196H30.9588C31.447 26.5196 31.8465 26.1201 31.8465 25.6319C31.8465 25.1436 31.447 24.7441 30.9588 24.7441H25.0406C24.5523 24.7441 24.1528 25.1436 24.1528 25.6319C24.1528 26.1201 24.5523 26.5196 25.0406 26.5196Z"
        fill="white"
      />
    </svg>
  );
}
